import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";
import { authenticatedFetch } from "../../../util/authenticatedFetch";
import {
  FETCH_BY_NAME_ERROR,
  FETCH_BY_NAME_REQUEST,
  FETCH_BY_NAME_RESET,
  FETCH_BY_NAME_SUCCESS,
} from "./ActionType";

let requestSequence = 0;

const createRequestMeta = (shopId) => {
  const normalizedShopId = String(shopId ?? "");
  requestSequence += 1;
  return {
    shopId: normalizedShopId,
    requestId: `fetchOrderByName:${normalizedShopId}:${Date.now()}:${requestSequence}`,
  };
};

const readResponsePayload = async (response) => {
  if (typeof response.text === "function") {
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (_error) {
      return { message: text };
    }
  }
  if (typeof response.json === "function") return response.json();
  return null;
};

const responseError = (payload, response) =>
  [payload?.message, payload?.error, payload?.detail].find(
    (value) => typeof value === "string" && value.trim()
  ) || `Order-name lookup failed (${response.status})`;

export const fetchByNameApi = (payload) => async (dispatch) => {
  const target = {
    shopId: String(payload?.storeId ?? ""),
    orderName: payload?.orderName || "",
  };
  const meta = createRequestMeta(target.shopId);
  dispatch({ type: FETCH_BY_NAME_REQUEST, meta });

  try {
    const response = await authenticatedFetch(
      `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.fetch_by_name}`,
      {
        method: "POST",
        body: JSON.stringify({
          orderName: target.orderName,
          storeId: target.shopId,
        }),
        credentials: "include",
        headers: {
          Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
          "Content-Type": "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      }
    );
    const data = await readResponsePayload(response);
    if (!response.ok) throw new Error(responseError(data, response));

    dispatch({ type: FETCH_BY_NAME_SUCCESS, payload: data, meta });
    return { ok: true, payload: data, meta };
  } catch (error) {
    const message = error?.message || "Order-name lookup failed";
    dispatch({ type: FETCH_BY_NAME_ERROR, payload: message, meta });
    return { ok: false, error: message, meta };
  }
};

export const resetFetchByName = () => ({ type: FETCH_BY_NAME_RESET });
